import { useId } from "react";
import CropImage from "../cropImage";

interface Props {
    imageUrl: string
    startAngle: number, // Начальный угол (0-360°)
    angle: number, // Размер сектора (например, 45°)
    radius: number,   // Радиус круга
    className?: string
}


const PizzaSlice = ({
    imageUrl,
    startAngle = 0,
    angle = 45,
    radius = 100,
    className,
}: Props) => {

    const id  = useId()

    const diameter = radius * 2

    let sliceMask

    

    if (angle < 360) {
        // Преобразуем углы в радианы
        const startRad = (startAngle * Math.PI) / 180;
        const endRad = ((startAngle + angle) * Math.PI) / 180;

        // Координаты начальной и конечной точек дуги
        const x1 = radius + radius * Math.cos(startRad);
        const y1 = radius + radius * Math.sin(startRad);
        const x2 = radius + radius * Math.cos(endRad);
        const y2 = radius + radius * Math.sin(endRad);

        // Определяем направление дуги (1 - большая дуга, 0 - малая)
        const largeArcFlag = angle <= 180 ? 0 : 1;

        // Формируем путь для маски
        const pathData = `
      M${radius},${radius} 
      L${x1},${y1} 
      A${radius},${radius} 0 ${largeArcFlag},1 ${x2},${y2} 
      Z
    `;

        sliceMask = <path d={pathData} fill="white" />
    } else {
        sliceMask = <circle cx={radius} cy={radius} r={radius} fill="white" />
    }

    const maskId = "pizza-mask" + id

    return (
        <svg key={id} className={className} width={diameter} height={diameter} viewBox={`0 0 ${diameter} ${diameter}`}>
            <defs>
                <mask id={maskId}>
                    {/* Белый фон = видимая часть */}
                    <rect width="100%" height="100%" fill="black" />
                    {/* Чёрный путь = вырезанная часть (всё, кроме сектора) */}
                    {sliceMask}
                </mask>
            </defs>
            
            <foreignObject width={diameter} height={diameter} mask={`url(#${maskId})`}>
                <CropImage src={imageUrl} width={diameter} height={diameter} />
            </foreignObject>
        </svg>
    );
};

export default PizzaSlice